import React from 'react'
import { RichText } from './helpers/react'
import SmartContainer from './helpers/entry/smart-container2'
import richTextStyles from './helpers/rich-text-styles'

const RichTextBlock = ({ styling, ...props }) => {
  const variant = pickVariant('elements', 'rich-text-block', props.variant, props.customVaraint)

  styling = {
    ...richTextStyles,
    ...styling,
  }
  return (
    <SmartContainer parentContentType={props.parentContentType} variant={variant} styling={styling}>
      <RichText {...props} />
    </SmartContainer>
  )
}

const pickVariant = (type, component, variant = 'base', customVariant) => {
  const baseVariant = variant === 'base' ? 'base' : `variants.${variant}`
  const finalVariant =
    customVariant && variant !== 'base' ? `variants.${customVariant}` : baseVariant

  return `${type}.${component}.${finalVariant}`
}

export default RichTextBlock
